import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `CambioEstadoVerraco`, method: 'GET', body: null, token: token})
}